import type { FC, MouseEventHandler } from "react";
import { useState } from "react";
import ArrowLeftIcon from "./ArrowLeftIcon";
import ArrowRigthIcon from "./ArrowRigthIcon";

type ArrowButtonName = "arrowLeft" | "arrowRight";

interface ArrowButtonProps {
  buttonName: ArrowButtonName;
  action: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const ArrowButton: FC<ArrowButtonProps> = ({
  buttonName,
  action,
  disabled = false,
}) => {
  const [hover, setHover] = useState(false);

  const getIcon = () => {
    switch (buttonName) {
      case "arrowLeft":
        return <ArrowLeftIcon disabled={disabled} hover={hover} />;
      case "arrowRight":
        return <ArrowRigthIcon disabled={disabled} hover={hover} />;
      default:
        return <ArrowLeftIcon disabled={disabled} />;
    }
  };

  return (
    <button
      type="button"
      onClick={action}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={`w-8 h-8 ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      {getIcon()}
    </button>
  );
};

export default ArrowButton;
